import { playerLoadThunkAction } from '../../player/actions/load';
import { PLAYER_CONTENT_KIND } from '../../player/constants';

export const vodGuidePlayItemThunkAction = (id) =>
  // eslint-disable-next-line no-unused-vars
  async (dispatch, getState) => {
    dispatch(
      playerLoadThunkAction({
        id,
        kind: PLAYER_CONTENT_KIND.VOD,
      }),
    );
  };
